import { create } from "zustand";
import { mountStoreDevtool } from "simple-zustand-devtools";
import { createJSONStorage, persist } from "zustand/middleware";
import { config_base } from "@/data/config_base";

const isDevMode = import.meta.env.DEV;

export type Side = "left" | "center" | "right";

export interface AppStoreState {
	side: Side;
	isDevMode: boolean;
	selectedProduct: string | null;
	productOptions: {
		pillarStyles: {
			showPillarFoot: boolean;
			[key: string]: any;
		};
		[key: string]: any;
	};
	update: (options: Partial<AppStoreState>) => void;
	configurator: {
		gate: {
			id: string;
			selectedDimensions: Record<string, number>;
			selectedModifiers: Array<{ id: string }>;
			selectedMaterials: Record<string, any>;
		};
		category: { id: string };
		pillar: {
			id: string;
			selectedDimensions: Record<string, number>;
			selectedModifiers: Array<{ id: string }>;
			selectedMaterials: Record<string, any>;
		};
	};
}

const DEFAULT_PRODUCT_PROPS = {
	steps: {},
	category: { id: "swing_gate", title: "Swing Gate" },
	gate: {
		...config_base.configurator.gates.find((gate) => gate.id === "swg_stockholm"),
		selectedDimensions: {
			center_height: 190,
			outer_height: 170,
			door_width: 150,
			door_frame_width: 10,
			door_frame_thickness: 15,
			door_plank_width: 5,
		},
		selectedMaterials: {
			swg_stockholm: config_base.configurator.materials.find((material) => material.id === "oak_light"),
			swg_san_francisco: config_base.configurator.materials.find((material) => material.id === "light_metal"),
		},
		selectedModifiers: [],
	},
	pillar: {
		...config_base.configurator.pillars.find((pillar) => pillar.id === "pillar_stockholm"),
		selectedDimensions: {
			pillar_width: 60,
			pillar_length: 60,
			pillar_foot_height: 10,
			pillar_foot_thickness: 10,
		},
		selectedModifiers: [config_base.configurator.modifiers.find((modifier) => modifier.id === "mailbox")],
		selectedMaterials: {
			pillar_stockholm: config_base.configurator.materials.find((material) => material.id === "oak_light"),
		},
	},
	doorStyles: {
		doorMaterial: "oak",
	},
	pillarStyles: {
		pillarShape: "stone_brick",
		pillarBaseMaterial: "brick_wall",
		pillarTopMaterial: "concrete",
		showPillarFoot: true,
	},
};

export const useAppStore = create(
	persist<AppStoreState>(
		(set) => ({
			side: "center",
			isDevMode,
			selectedProduct: null,
			configurator: { ...DEFAULT_PRODUCT_PROPS },
			productOptions: { ...DEFAULT_PRODUCT_PROPS },
			update: (options) => set((state) => ({ ...state, ...options })),
		}),
		{
			name: "app-store",
			version: 1,
			storage: createJSONStorage(() => sessionStorage),
		}
	)
);

if (isDevMode) {
	mountStoreDevtool("AppStore", useAppStore);
}
